export const GRID_SIZE = 20
export const INPUT_UUID_KEY = '-input'
export const OUTPUT_UUID_KEY = '-output'
export const getBackgroundStyles = (
    scale,
    offsetPosition,
    executionPreview
) => {
    const squareSize = GRID_SIZE * scale
    const dotSize = 1 * scale
    const dotPosition = (GRID_SIZE / 2) * scale

    if (executionPreview) {
        return {
            'background-image':
                'linear-gradient(135deg, #f9f9fb 25%, #ffffff 25%, #ffffff 50%, #f9f9fb 50%, #f9f9fb 75%, #ffffff 75%, #ffffff 100%)',
            'background-size': `${squareSize}px ${squareSize}px`,
            'background-position': `left ${offsetPosition[0]}px top ${offsetPosition[1]}px`
        }
    }

    const styles = {
        'background-size': `${squareSize}px ${squareSize}px`,
        'background-position': `left ${offsetPosition[0]}px top ${offsetPosition[1]}px`
    }
    if (squareSize > 10.5) {
        const dotColor = 'rgb(218, 224, 228)'
        return {
            ...styles,
            'background-image': `radial-gradient(circle at ${dotPosition}px ${dotPosition}px, ${dotColor} ${dotSize}px, transparent 0)`
        }
    }

    return styles
}

export function getStyleTokenValue (name) {
    const style = getComputedStyle(document.body)
    return style.getPropertyValue(name)
}

export const getOutputEndpointUUID = (nodeId, outputIndex) => {
    return `${nodeId}${OUTPUT_UUID_KEY}${outputIndex}`
}

export const getInputEndpointUUID = (nodeId, inputIndex) => {
    return `${nodeId}${INPUT_UUID_KEY}${inputIndex}`
}
